import { Activity, Settings, ShieldCheck, Users } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

import { MANAGE } from './manage';

export const platformOperationsTour = defineTour({
  id: 'platform.operations',
  version: 1,
  group: 'platform-team',
  route: '/_authed/operations',
  scope: 'org',
  icon: Activity,
  steps: [
    { id: 'stats', kind: 'explain', target: 'platform.operations.stats' },
    { id: 'queues', kind: 'explain', target: 'platform.operations.queues', optional: true },
    {
      id: 'search',
      kind: 'explain',
      target: 'platform.operations.search',
      placement: 'top',
      optional: true,
    },
    {
      id: 'reindex-all',
      kind: 'explain',
      target: 'platform.operations.reindex-all',
      requires: MANAGE,
      optional: true,
      waitMs: 1000,
    },
    { id: 'refresh', kind: 'explain', target: 'platform.operations.refresh' },
  ],
  related: ['platform.settings'],
});

export const platformUsersTour = defineTour({
  id: 'platform.users',
  version: 1,
  group: 'platform-team',
  route: '/_authed/users',
  scope: 'org',
  icon: Users,
  steps: [
    { id: 'table', kind: 'explain', target: 'platform.users.table', placement: 'top' },
    { id: 'roles', kind: 'explain', target: 'platform.users.roles' },
    { id: 'create', kind: 'explain', target: 'platform.users.create', requires: MANAGE },
    { id: 'status', kind: 'explain', target: 'platform.users.status', requires: MANAGE },
  ],
  related: ['platform.security'],
});

export const platformSettingsTour = defineTour({
  id: 'platform.settings',
  version: 1,
  group: 'platform-team',
  route: '/_authed/settings',
  scope: 'org',
  icon: Settings,
  steps: [
    { id: 'email', kind: 'explain', target: 'platform.settings.email', placement: 'right' },
    {
      id: 'email-check',
      kind: 'explain',
      target: 'platform.settings.email-check',
      requires: MANAGE,
    },
    {
      id: 'email-send',
      kind: 'explain',
      target: 'platform.settings.email-send',
      requires: MANAGE,
    },
  ],
  related: ['platform.operations'],
});

export const platformSecurityTour = defineTour({
  id: 'platform.security',
  version: 1,
  group: 'platform-team',
  route: '/_authed/account/security',
  scope: 'org',
  icon: ShieldCheck,
  steps: [
    { id: 'status', kind: 'explain', target: 'platform.security.status' },
    {
      id: 'setup',
      kind: 'explain',
      target: 'platform.security.setup',
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'codes-left',
      kind: 'explain',
      target: 'platform.security.codes-left',
      optional: true,
      waitMs: 1000,
    },
  ],
  related: ['platform.users'],
});
